import React, { useState } from 'react';
import { ChevronUp } from 'lucide-react';

/**
 * Carte qui révèle son contenu au survol (desktop)
 * ou au toucher (mobile/tablette, via le state `open`).
 */
function HoverSlideCard({ title, imageSrc, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="group relative w-full max-w-lg h-[500px] mx-auto overflow-hidden rounded-2xl shadow-[0_20px_40px_rgba(0,0,0,0.4)] bg-[#1a1a1a] border-2 border-[#7A4B9E]/30 cursor-pointer"
      onClick={() => setOpen((o) => !o)}
      role="button"
      tabIndex={0}
      aria-expanded={open}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setOpen((o) => !o);
        }
      }}
    >
      {/* Slide 1: Image & Title (Default State) */}
      <div className={`absolute inset-0 w-full h-full transition-transform duration-500 ease-in-out group-hover:-translate-y-[100px] ${open ? '-translate-y-[100px]' : ''} z-10 bg-[#1a1a1a] flex flex-col`}>
        <div className="relative w-full h-full">
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent z-10" />
          <img
            src={imageSrc}
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-0 left-0 w-full p-6 z-20 flex items-end justify-between gap-4">
            <div>
              <h2 className="font-pixel text-3xl md:text-4xl text-white drop-shadow-md mb-2">
                {title}
              </h2>
              <div className="w-16 h-1 bg-[#7A4B9E] rounded-full" />
            </div>
            {/* Indice tactile (mobile uniquement, le survol suffit sur desktop) */}
            <span className="lg:hidden flex items-center gap-1 text-white/80 text-xs font-bold uppercase tracking-wider bg-black/40 rounded-full px-3 py-1.5 shrink-0">
              Lire <ChevronUp className="w-3.5 h-3.5" />
            </span>
          </div>
        </div>
      </div>

      {/* Slide 2: Text Content (Hover/Tap State) */}
      <div className={`absolute inset-0 w-full h-full bg-[#7A4B9E] transition-transform duration-500 ease-in-out group-hover:translate-y-0 ${open ? 'translate-y-0' : 'translate-y-full'} z-20 flex flex-col`}>
        {/* Header inside the slide to keep context */}
        <div className="p-6 pb-4 border-b border-white/20 bg-[#7A4B9E] shrink-0 flex items-center justify-between gap-4">
          <h2 className="font-pixel text-2xl text-white">
            {title}
          </h2>
          <span className="lg:hidden text-white/70 text-xs font-bold uppercase tracking-wider shrink-0">
            Fermer
          </span>
        </div>

        {/* Scrollable Content */}
        <div className="p-6 overflow-y-auto custom-scrollbar text-gray-100 space-y-4 text-sm md:text-base leading-relaxed">
          {children}
        </div>
      </div>

    </div>
  );
}

export default HoverSlideCard;
